"use client";
// @ts-strict-ignore
import * as React from "react";
import NextLink from "components/parts/NextLink";
import Button from "components/parts/button";
import { Container, InnerContainer } from "components/pages/Clearing/style";
import { Wrapper, Headline, SubHeading, ReasonHeading } from "./style";
import { useTranslations } from "i18n";
import { FILES } from "i18n/constants";
import { capitalize } from "components/parts/Typography/utils";

interface Props {
  linkTo?: string;
}

const MAIN_PAGES = ["blog", "learn", "prices", "cryptopedia", "legal", "fees"];

const getLinkTo = (linkTo: string, t: any) => {
  if (MAIN_PAGES.includes(linkTo))
    return {
      link: `/${linkTo}`,
      text: t("notFoundLink", { page: capitalize(linkTo) })
    };
  return { link: "/", text: t("notFoundLink", { page: capitalize("Home") }) };
};

export const NotFound = ({ linkTo, ...rest }: Props) => {
  const t = useTranslations(FILES.COMMON);
  const HEADLINE_TEXT = t("notFoundTitle");
  const SUBHEADING = t("notFoundSubheading");
  const REASON = t("notFoundReason");
  return (
    <Container {...rest}>
      <InnerContainer>
        <Wrapper>
          <Headline>{HEADLINE_TEXT}</Headline>
          <SubHeading>{SUBHEADING}</SubHeading>
          <ReasonHeading>{REASON}</ReasonHeading>
          <NextLink href={getLinkTo(linkTo ?? "", t).link}>
            <Button isPrimary>{getLinkTo(linkTo ?? "", t).text}</Button>
          </NextLink>
        </Wrapper>
      </InnerContainer>
    </Container>
  );
};

export default NotFound;
